export default {
  title: 'Betal med Pix',
  hint: 'Kopier koden, og indsæt den i Pix i din bank-app, eller scan QR-koden med den.',
  copy: 'Kopier Pix-kode',
  copied: 'Kode kopieret',
  qr_alt: 'Pix QR-kode',
  expires_in: 'Koden udløber om {{time}}',
  waiting: 'Vi bekræfter din ordre, så snart din bank sender betalingen.',
  open_page: 'Åbn betalingssiden i stedet',
  expired: 'Denne Pix-kode er udløbet. Start betalingen igen for at få en ny.',
  cancel: 'Annuller betaling',
  checking: 'Tjekker din betaling…',
  close: 'Luk',
};
